module.exports = __webpack_public_path__ + "static/media/tese_janira.4371fa4c.png";